import { DestinationIcon } from '../../icons/DestinationIcon';
import { HistoryIcon } from '../../icons/HistoryIcon';
import { HotelIcon } from '../../icons/HotelIcon';
import { CategoryType } from '../../services/ContentService/ContentService.types';

export const CATEGORY_ICONS: Record<CategoryType, React.FC> = {
  PolygonCityZone: DestinationIcon,
  Hotel: HotelIcon,
  RecentSearches: HistoryIcon,
};

export const TOP_SEARCHES_LIMIT = 5;
